import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';
import { VoucherApi } from 'common/api/resources/Voucher';

import { Loading } from './../Loading';
import { toApiError } from 'common/utils/api';

interface DialogResendEligibleEmailProps {
  isOpen?: boolean;
  confirmLabel?: string;
  email?: string;
  cancelLabel?: string;
  closeLabel?: string;
  memberId?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  loadingMessage?: string;
  error?: string;
  success?: string;
}

interface DialogResendEligibleEmailValues {
  productType?: string;
}
interface DialogResendEligibleEmailValuesState {
  isLoading: boolean;
  error: string;
}
export class DialogResendEligibleEmail extends React.Component<
  DialogResendEligibleEmailProps,
  DialogResendEligibleEmailValuesState
> {
  state: DialogResendEligibleEmailValuesState = { isLoading: false, error: '' };
  initialValues() {
    return {
      productType: 'BADGE',
    };
  }

  handleSubmit = async (values: DialogResendEligibleEmailValues) => {
    await this.setState({ isLoading: true, error: '' });
    if (this.props.memberId && values.productType) {
      VoucherApi.resendemail(this.props.memberId, values.productType)
        .then(() => {
          this.setState({ isLoading: false });
          this.props.onConfirm();
        })
        .catch(e => {
          this.setState({ isLoading: false });
          this.setState({ error: toApiError(e) });
        });
    } else {
      this.setState({ isLoading: false });
      this.setState({ error: 'MemberId and ProductType is Required.' });
    }
  };
  render() {
    const props = this.props;
    const { isLoading } = this.state;
    return (
      <Modal size="md" isOpen={props.isOpen} toggle={props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<DialogResendEligibleEmailValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={props.onCancel}>Resend Learning Program Email</ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col">
                    <FormInput
                      id="productType"
                      name="productType"
                      label="Learning Program"
                      tag="select"
                      autoComplete="off"
                    >
                      <option value="BADGE">BADGE</option>
                      <option value="CERT_NEW">CERTIFICATION</option>
                    </FormInput>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                {!props.success && (
                  <div>
                    <Button
                      disabled={isLoading}
                      color="secondary"
                      onClick={props.onCancel}
                      data-testid="DialogResendEligibleEmailAction"
                    >
                      {props.cancelLabel ? props.cancelLabel : 'Cancel'}
                    </Button>{' '}
                    <Button
                      disabled={isLoading}
                      color="primary"
                      type="submit"
                      data-testid="DialogResendEligibleEmailAction"
                    >
                      {props.confirmLabel ? props.confirmLabel : 'Confirm'}
                    </Button>
                  </div>
                )}
                {props.success && (
                  <Button
                    color="primary"
                    disabled={isLoading}
                    onClick={props.onCancel}
                    data-testid="DialogResendEligibleEmailAction"
                  >
                    {props.closeLabel ? props.closeLabel : 'Close'}
                  </Button>
                )}
              </ModalFooter>
              {this.state.error && (
                <div className="alert alert-danger" style={{ margin: 10 }}>
                  {this.state.error}
                </div>
              )}
              {props.success && (
                <div className="alert alert-success" style={{ margin: 10 }}>
                  {props.success}
                </div>
              )}
              {isLoading && (
                <div style={{ margin: 10 }}>
                  <Loading message={props.loadingMessage} />
                </div>
              )}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/DialogResendEligibleEmail.tsx